import React, { useCallback, useMemo } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => props => {
  const { openNotification } = hooks.useNotification()
  const CODE_INTERNATIONAL = hooks.useRelayConstant('CODE_INTERNATIONAL')
  const setFormValues = hooks.useFormChange()
  const [{ commercial_package, vehicle_count, companyservice_id }] = hooks.useFormState()
  const [guest, load_count] = hooks.useFieldValues(['guest', 'load_count'])
  const [cp] = hooks.useModel('commercialpackage', [commercial_package], { single: true })
  const [user_id] = hooks.useActiveUser({ mutator: 'user_id' })
  const [service] = hooks.useModel('companyservice', [companyservice_id], { single: true, populate: ['contract'] })
  const [ownCompanyUser] = hooks.useModelSearch('companyuser', 'get', {
    forced_filter: { user: user_id, company: service?.contract?.company },
    watchers: [user_id, service?.contract?.company],
    single: true,
    limit: 1,
  })

  const [, searchSelectedCompanyUser] = hooks.useModelSearch('companyuser', 'get', {
    single: true,
    limit: 1,
    populate: ['user.info', 'user.auth', 'user.customerinfo', 'contact']
  })

  const max_load = cp?.max_load || 4
  const guest_booking = ownCompanyUser?.guest_booking
  const booking_level = ownCompanyUser?.booking_level
  const companyuser_id = ownCompanyUser?.companyuser_id
  const self_booking = ownCompanyUser?.self_booking
  const company = ownCompanyUser?.company
  const companycontract_id = service?.contract?.companycontract_id

  const onDecrementLoadCount = useCallback(Callbacks.onDecrementLoadCountHandler(setFormValues, openNotification, load_count), [setFormValues, openNotification, load_count])
  const onIncrementLoadCount = useCallback(Callbacks.onIncrementLoadCountHandler(setFormValues, openNotification, load_count, max_load, vehicle_count), [setFormValues, openNotification, load_count, max_load, vehicle_count])
  const onCompanyuserChange = useCallback(Callbacks.onCompanyuserChangeHandler(setFormValues, searchSelectedCompanyUser), [setFormValues, searchSelectedCompanyUser])
  const getCompanyuserFilter = useCallback(Callbacks.getCompanyuserFilterHandler(), [])
  const getCompanyuserValidate = useCallback(Callbacks.getCompanyuserValidateHandler(booking_level, self_booking), [booking_level, self_booking])
  const normalizePhone = useCallback(Callbacks.normalizePhoneHandler(CODE_INTERNATIONAL), [CODE_INTERNATIONAL])

  const companyuser_watchers = [companyuser_id, company, companycontract_id, booking_level, self_booking, companyservice_id]

  const disabledPassenger = useMemo(() => vehicle_count > 1 || (!guest && !!companyuser_id), [vehicle_count, guest, companyuser_id])
  const displayGuestField = useMemo(() => vehicle_count > 1 || !!guest_booking, [vehicle_count, guest_booking])
  const displayPassengerList = useMemo(() => !!booking_level && !guest, [booking_level, guest])
  const displayPassengerText = useMemo(() => {
    const isBookingBySelfOrGuest = !!self_booking || !!guest_booking
    const hasNoBookingLevelOrGuest = !booking_level || !!guest
    return (hasNoBookingLevelOrGuest && isBookingBySelfOrGuest) || !companyuser_id
  }, [booking_level, guest, self_booking, guest_booking, companyuser_id])

  const mergedProps = {
    companyuser_watchers,
    max_load,
    displayPassengerText,
    displayPassengerList,
    disabledPassenger,
    displayGuestField,
    getCompanyuserFilter,
    getCompanyuserValidate,
    onCompanyuserChange,
    onDecrementLoadCount,
    onIncrementLoadCount,
    normalizePhone
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}

export default withContainer
